import { categories } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-configuration/categories';
import type { GoalSchema } from 'containers/admin/clients/client/tabs-components/goals-tab/types';

export const Rate: GoalSchema = {
  Rate: {
    subType: [
      {
        value: 'Admit Rate',
        label: 'Admit Rate',
        valueType: 'PERCENT',
      },
      {
        value: 'Yield',
        label: 'Yield',
        valueType: 'PERCENT',
      },
    ],
    categories,
  },
};
